// extracted by mini-css-extract-plugin
module.exports = {"overlay":"hero-module--overlay--1XB9-","hero":"hero-module--hero--3-52N","headline":"hero-module--headline--FYB6K"};